
<app-user-avatar [user]="user()" class="profile-info__avatar"/>
<div class="profile-info__info">
	<span class="profile-info__user-name mat-body-large">{{ user().name }}</span>
	<span class="mat-body-small">{{ user().job }}</span>
	<span class="mat-body-small">{{ user().email }}</span>
</div>
